import { EMAIL_REGEX, TEXTFIELD_ALLOW } from "constants/regex";
import * as Yup from "yup";
import eaw from "eastasianwidth";

export const validationSchema = (t) =>
  Yup.object().shape({
    clinic_name: Yup.string()
      .max(255, t("messages.MSG-USP052", { number: 255 }))
      .required()
      .test("confirm1", t("messages.MSG-USP029"), (value) => {
        if (TEXTFIELD_ALLOW.FULL_WIDTH_HIRA_KANA_KANJI.test(value)) {
          return false;
        }

        return true;
      }),
    clinic_name_furigana: Yup.string()
      .max(255, t("messages.MSG-USP052", { number: 255 }))
      .required()
      .test("confirm1", t("messages.MSG-USP030"), (value) => {
        if (TEXTFIELD_ALLOW.FULL_WIDTH_FURIGANA.test(value)) {
          return false;
        }

        return true;
      }),
    address: Yup.object().shape({
      postal_code: Yup.string()
        .max(7, t("messages.MSG-USP052", { number: 7 }))
        .required()
        .test(
          "check_half_size",
          t("messages.MSG-USP052", { number: 7 }),
          (value) => {
            if (value && eaw.length(value) !== value.length) {
              return false;
            }
            return true;
          }
        ),
      province: Yup.string()
        .required()
        .max(255, t("messages.MSG-USP052", { number: 255 })),
      name: Yup.string()
        .max(255, t("messages.MSG-USP052", { number: 255 }))
        .required(),
      building: Yup.string()
        .max(255, t("messages.MSG-USP052", { number: 255 }))
        .required(),
    }),
    phone_number: Yup.string()
      .max(15, t("messages.MSG-USP084"))
      .min(10, t("messages.MSG-USP084"))
      .required()
      .test("check_half_size", t("messages.MSG-USP084"), (value) => {
        if (value && eaw.length(value) !== value.length) {
          return false;
        }
        return true;
      }),
    email: Yup.string()
      .max(255, t("messages.MSG-USP052", { number: 255 }))
      .required()
      .matches(EMAIL_REGEX, t("messages.MSG-USP001")),
    confirmEmail: Yup.string()
      .max(255, t("messages.MSG-USP052", { number: 255 }))
      .required()
      .test("confirm", t("messages.MSG-USP015"), (value, context) => {
        if (value !== context.parent?.email) return false;
        return true;
      }),
    decode_password: Yup.string()
      .min(8, t("messages.MSG-USP003"))
      .max(36, t("messages.MSG-USP003"))
      .required()
      .test("check_size", t("messages.MSG-USP003"), (value) => {
        if (value && eaw.length(value) !== value.length) {
          return false;
        }
        return true;
      }),
    confirmPassword: Yup.string()
      .min(8, t("messages.MSG-USP003"))
      .max(36, t("messages.MSG-USP003"))
      .required()
      .test((value, context) => {
        if (value !== context.parent?.decode_password) {
          return context.createError({
            path: context.path,
            message: t("messages.MSG-USP011"),
          });
        }

        if (value && eaw.length(value) !== value.length) {
          return context.createError({
            path: context.path,
            message: t("messages.MSG-USP003"),
          });
        }

        return true;
      }),
  });


  export const validationSchemaEdit = (t) =>
    Yup.object().shape({
      clinic_name: Yup.string()
        .max(255, t("messages.MSG-USP052", { number: 255 }))
        .required()
        .test("confirm1", t("messages.MSG-USP101"), (value) => {
          if (TEXTFIELD_ALLOW.FULL_WIDTH_HIRA_KANA_KANJI.test(value)) {
            return false;
          }
  
          return true;
        }),
      clinic_name_furigana: Yup.string()
        .max(255, t("messages.MSG-USP052", { number: 255 }))
        .required()
        .test("confirm1", t("messages.MSG-USP102"), (value) => {
          if (TEXTFIELD_ALLOW.FULL_WIDTH_FURIGANA.test(value)) {
            return false;
          }
  
          return true;
        }),
      address: Yup.object().shape({
        postal_code: Yup.string()
          .max(7, t("messages.MSG-USP052", { number: 7 }))
          .required()
          .test(
            "check_half_size",
            t("messages.MSG-USP052", { number: 7 }),
            (value) => {
              if (value && eaw.length(value) !== value.length) {
                return false;
              }
              return true;
            }
          ),
        province: Yup.string()
          .required()
          .max(255, t("messages.MSG-USP052", { number: 255 })),
        name: Yup.string()
          .max(255, t("messages.MSG-USP052", { number: 255 }))
          .required(),
        building: Yup.string()
          .max(255, t("messages.MSG-USP052", { number: 255 }))
          .required(),
      }),
      phone_number: Yup.string()
        .max(15, t("messages.MSG-USP084"))
        .min(10, t("messages.MSG-USP084"))
        .required()
        .test("check_half_size", t("messages.MSG-USP084"), (value) => {
          if (value && eaw.length(value) !== value.length) {
            return false;
          }
          return true;
        }),
      email: Yup.string()
        .max(255, t("messages.MSG-USP052", { number: 255 }))
        .required()
        .matches(EMAIL_REGEX, t("messages.MSG-USP001")),
      confirmEmail: Yup.string()
        .max(255, t("messages.MSG-USP052", { number: 255 }))
        .required()
        .test("confirm", t("messages.MSG-USP015"), (value, context) => {
          if (value !== context.parent?.email) return false;
          return true;
        }),
      decode_password: Yup.string()
        .min(8, t("messages.MSG-USP003"))
        .max(36, t("messages.MSG-USP003"))
        .required()
        .test("check_size", t("messages.MSG-USP003"), (value) => {
          if (value && eaw.length(value) !== value.length) {
            return false;
          }
          return true;
        }),
      confirmPassword: Yup.string()
        .min(8, t("messages.MSG-USP003"))
        .max(36, t("messages.MSG-USP003"))
        .required()
        .test((value, context) => {
          if (value !== context.parent?.decode_password) {
            return context.createError({
              path: context.path,
              message: t("messages.MSG-USP011"),
            });
          }
  
          if (value && eaw.length(value) !== value.length) {
            return context.createError({
              path: context.path,
              message: t("messages.MSG-USP003"),
            });
          }
  
          return true;
        }),
    });
